import { useEffect, useRef } from "react";

import styles from "./index.module.css";

export default function Swiper({
  children,
  slidesPerView = 1,
  spaceBetween = 50,
  autoplay = false,
  pagination = false,
  navigation = false,
  breakpoints = {},
}) {
  const swiperRef = useRef(null);

  useEffect(() => {
    // Object with parameters
    const params = {
      slidesPerView,
      autoplay,
      pagination,
      navigation,
      spaceBetween,
      breakpoints,
      injectStyles: [
        `.swiper-button-next svg, .swiper-button-prev svg {
          transform : scale(0.5)
          
        }`,
      ],
    };

    // Assign it to swiper element
    Object.assign(swiperRef.current, params);

    // initialize swiper
    swiperRef.current.initialize();
  }, []);

  return (
    <swiper-container init="false" ref={swiperRef} class={styles.container}>
      {children}
    </swiper-container>
  );
}
Swiper.Slide = function SwiperSlide({ children }) {
  return <swiper-slide class={styles.slide}>{children}</swiper-slide>;
};
